var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-sm-12 chart-row" },
      [
        _c("overview-chart", {
          attrs: {
            value:
              _vm.filter === "future" ? _vm.futureOverview : _vm.todaysOverview,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-sm-6" },
      [
        _c("overview-summary", {
          attrs: {
            title: "Total Retirement Benefit",
            value:
              _vm.filter === "future"
                ? _vm.futureTotalRetirementBenefit
                : _vm.todaysTotalRetirementBenefit,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-sm-6" },
      [
        _c("overview-summary", {
          attrs: {
            title: "Present Value*",
            value:
              _vm.filter === "future"
                ? _vm.futurePresentValue
                : _vm.todaysPresentValue,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c("more-info", {
          attrs: { moreInfo: _vm.moreInfo.overview },
          on: { click: _vm.moreInfoOpen },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }